module.exports = __webpack_public_path__ + "0984abad587ff59d494e151cc4844d42.png";